// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../core/resource.mjs";
import { path } from "../internal/utils/path.mjs";
export class Environments extends APIResource {
    /**
     * Get a specific environment connection by deviceId
     */
    retrieve(deviceID, options) {
        return this._client.get(path `/v1/environments/${deviceID}`, options);
    }
    /**
     * List all active environment connections for the organization
     */
    list(query = {}, options) {
        return this._client.get('/v1/environments', { query, ...options });
    }
    /**
     * Send a message to a specific environment connection
     */
    sendMessage(connectionID, body, options) {
        return this._client.post(path `/v1/environments/${connectionID}/messages`, { body, ...options });
    }
}
//# sourceMappingURL=environments.mjs.map